// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floating panel for moving an aggregation node. Matches the dark
   aggregation-node form it sits alongside. */

.node-move-panel {
  position: fixed;
  top: 88px;
  right: 16px;
  z-index: 1100;
  width: min(360px, calc(100vw - 32px));
  max-height: calc(var(--app-height, 100dvh) - 120px);
  display: flex;
  flex-direction: column;
  background: rgba(9, 12, 23, 0.98);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  color: #f8fafc;
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 13px;
  overflow: hidden;
}

.node-move-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.15);
}

.node-move-panel__header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.node-move-panel__close {
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.node-move-panel__close:hover {
  color: #f8fafc;
}

.node-move-panel__body {
  padding: 12px 14px;
  overflow-y: auto;
}

.node-move-panel__lead {
  margin: 0 0 10px;
  color: #cbd5e1;
}

.node-move-panel__find {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}

.node-move-panel__find input {
  flex: 1;
  min-width: 0;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  background: rgba(15, 23, 42, 0.9);
  color: #f8fafc;
}

.node-move-panel__find button,
.node-move-panel__move,
.node-move-panel__undo {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: #0284c7;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

.node-move-panel__find button:disabled,
.node-move-panel__move:disabled,
.node-move-panel__undo:disabled {
  opacity: 0.6;
  cursor: default;
}

.node-move-panel__section {
  margin-bottom: 10px;
}

.node-move-panel__heading {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 4px;
}

.node-move-panel__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.node-move-panel__row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: none;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.node-move-panel__row:hover {
  background: rgba(56, 189, 248, 0.1);
}

.node-move-panel__row.is-selected {
  border-color: #38bdf8;
  background: rgba(56, 189, 248, 0.15);
}

.node-move-panel__badge {
  flex: 0 0 20px;
  height: 20px;
  border-radius: 50%;
  background: #1e293b;
  border: 1px solid #38bdf8;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.node-move-panel__label {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.node-move-panel__meta {
  margin-left: auto;
  color: #94a3b8;
  font-size: 12px;
  white-space: nowrap;
}

.node-move-panel__empty,
.node-move-panel__hint {
  color: #94a3b8;
  padding: 4px 2px;
}

.node-move-panel__hint {
  font-size: 12px;
}

.node-move-panel__notice {
  padding: 6px 8px;
  border-radius: 6px;
  background: rgba(250, 204, 21, 0.12);
  color: #fde68a;
}

.node-move-panel__error {
  padding: 6px 8px;
  margin-top: 6px;
  border-radius: 6px;
  background: rgba(248, 113, 113, 0.14);
  color: #fecaca;
}

.node-move-panel__footer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-top: 1px solid rgba(148, 163, 184, 0.15);
}

.node-move-panel__summary {
  flex: 1;
  min-width: 0;
}

.node-move-panel__summary--idle {
  color: #94a3b8;
}

.node-move-panel__warning {
  margin-top: 4px;
  color: #fbbf24;
  font-size: 12px;
}

/* After a move: a compact bar with Undo */
.node-move-panel--notice {
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
}

.node-move-panel--notice > span {
  flex: 1;
  min-width: 0;
}

/* Numbered pins drawn on the map */
.node-move-pin {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #0f172a;
  border: 2px solid #38bdf8;
  color: #f8fafc;
  font: 700 11px/20px 'Inter', ui-sans-serif, system-ui, sans-serif;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
  cursor: pointer;
}

.node-move-pin--hover {
  transform: scale(1.2);
}

.node-move-pin--selected {
  background: #0284c7;
  border-color: #f8fafc;
}

/* While picking, the map shows a crosshair instead of the grab hand */
.leaflet-container.node-move-picking,
.leaflet-container.node-move-picking .leaflet-interactive {
  cursor: crosshair;
}
`, "",{"version":3,"sources":["webpack://./src/features/home/styles/node-move-panel.css"],"names":[],"mappings":"AAAA;6CAC6C;;AAE7C;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,mDAAmD;EACnD,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,yGAAyG;EACzG,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iEAAiE;EACjE,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sEAAsE;AACtE;;EAEE,iBAAiB;AACnB","sourcesContent":["/* Floating panel for moving an aggregation node. Matches the dark\n   aggregation-node form it sits alongside. */\n\n.node-move-panel {\n  position: fixed;\n  top: 88px;\n  right: 16px;\n  z-index: 1100;\n  width: min(360px, calc(100vw - 32px));\n  max-height: calc(var(--app-height, 100dvh) - 120px);\n  display: flex;\n  flex-direction: column;\n  background: rgba(9, 12, 23, 0.98);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);\n  color: #f8fafc;\n  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-size: 13px;\n  overflow: hidden;\n}\n\n.node-move-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.15);\n}\n\n.node-move-panel__header h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.node-move-panel__close {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.node-move-panel__close:hover {\n  color: #f8fafc;\n}\n\n.node-move-panel__body {\n  padding: 12px 14px;\n  overflow-y: auto;\n}\n\n.node-move-panel__lead {\n  margin: 0 0 10px;\n  color: #cbd5e1;\n}\n\n.node-move-panel__find {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.node-move-panel__find input {\n  flex: 1;\n  min-width: 0;\n  padding: 6px 8px;\n  border-radius: 6px;\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  background: rgba(15, 23, 42, 0.9);\n  color: #f8fafc;\n}\n\n.node-move-panel__find button,\n.node-move-panel__move,\n.node-move-panel__undo {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  background: #0284c7;\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.node-move-panel__find button:disabled,\n.node-move-panel__move:disabled,\n.node-move-panel__undo:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.node-move-panel__section {\n  margin-bottom: 10px;\n}\n\n.node-move-panel__heading {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 4px;\n}\n\n.node-move-panel__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.node-move-panel__row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: none;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.node-move-panel__row:hover {\n  background: rgba(56, 189, 248, 0.1);\n}\n\n.node-move-panel__row.is-selected {\n  border-color: #38bdf8;\n  background: rgba(56, 189, 248, 0.15);\n}\n\n.node-move-panel__badge {\n  flex: 0 0 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #1e293b;\n  border: 1px solid #38bdf8;\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.node-move-panel__label {\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.node-move-panel__meta {\n  margin-left: auto;\n  color: #94a3b8;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.node-move-panel__empty,\n.node-move-panel__hint {\n  color: #94a3b8;\n  padding: 4px 2px;\n}\n\n.node-move-panel__hint {\n  font-size: 12px;\n}\n\n.node-move-panel__notice {\n  padding: 6px 8px;\n  border-radius: 6px;\n  background: rgba(250, 204, 21, 0.12);\n  color: #fde68a;\n}\n\n.node-move-panel__error {\n  padding: 6px 8px;\n  margin-top: 6px;\n  border-radius: 6px;\n  background: rgba(248, 113, 113, 0.14);\n  color: #fecaca;\n}\n\n.node-move-panel__footer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border-top: 1px solid rgba(148, 163, 184, 0.15);\n}\n\n.node-move-panel__summary {\n  flex: 1;\n  min-width: 0;\n}\n\n.node-move-panel__summary--idle {\n  color: #94a3b8;\n}\n\n.node-move-panel__warning {\n  margin-top: 4px;\n  color: #fbbf24;\n  font-size: 12px;\n}\n\n/* After a move: a compact bar with Undo */\n.node-move-panel--notice {\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n}\n\n.node-move-panel--notice > span {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Numbered pins drawn on the map */\n.node-move-pin {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #0f172a;\n  border: 2px solid #38bdf8;\n  color: #f8fafc;\n  font: 700 11px/20px 'Inter', ui-sans-serif, system-ui, sans-serif;\n  text-align: center;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);\n  cursor: pointer;\n}\n\n.node-move-pin--hover {\n  transform: scale(1.2);\n}\n\n.node-move-pin--selected {\n  background: #0284c7;\n  border-color: #f8fafc;\n}\n\n/* While picking, the map shows a crosshair instead of the grab hand */\n.leaflet-container.node-move-picking,\n.leaflet-container.node-move-picking .leaflet-interactive {\n  cursor: crosshair;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
